import React from "react";

function SearchButton(props) {
  return <button className="btn btn-primary">{props.searchbtn}</button>;
}

export default SearchButton;
